import React from 'react';
import { Tooltip } from 'antd';
import './StyleFormateTools.scss';

const StyleFormateTools = ({
  click = () => {}, // 每个block的点击事件
}) => (
  <div className="tools-box">
    <Tooltip
      className="tool-item bold"
      onClick={() => click('BOLD')}
      title="Bold"
    >
      <div className="tool-btn">
        <div className="list-btn">
          <span className="appkiticon icon-richeditor-bold" />
        </div>
      </div>
    </Tooltip>

    <Tooltip
      className="tool-item italic"
      onClick={() => click('ITALIC')}
      title="Italic"
    >
      <div className="tool-btn">
        <div className="list-btn">
          <span className="appkiticon icon-richeditor-italic" />
        </div>
      </div>
    </Tooltip>

    <Tooltip
      className="tool-item decoration"
      onClick={() => click('UNDERLINE')}
      title="Underline"
    >
      <div className="tool-btn">
        <div className="list-btn">
          <span className="appkiticon icon-richeditor-underline" />
        </div>
      </div>
    </Tooltip>

    <Tooltip
      className="tool-item unordered-list"
      onClick={() => click('unordered-list-item')}
      title="Unordered List"
    >
      <div className="tool-btn">
        <div className="list-btn">
          <span className="appkiticon icon-list-view-fill" />
        </div>
      </div>
    </Tooltip>

    <Tooltip
      className="tool-item ordered-list"
      onClick={() => click('ordered-list-item')}
      title="Ordered List"
    >
      <div className="tool-btn">
        <div className="list-btn">
          <span className="appkiticon icon-richeditor-ol " />
        </div>
      </div>
    </Tooltip>
  </div>
);
StyleFormateTools.propTypes = {};
export default StyleFormateTools;
